import { Heading, Text } from "@afa-shared/afa-components";

import fundingListCardStyles from "./FundingListCard.module.css";

export interface IFundingListCardProps {
  nextImage?: any;
  heading?: string;
  headingVariant?: "h2" | "h3" | "h4" | "h5" | "h6";
  text?: any;
  linkUrl?: string;
  fundingOpeningDate: string;
  fundingClosingDate: string;
}

const FundingListCard = ({
  nextImage,
  heading,
  headingVariant = "h2",
  text,
  fundingOpeningDate,
  fundingClosingDate,
}: IFundingListCardProps): React.ReactNode => {
  return (
    <div className={fundingListCardStyles.fundingListCard}>
      {nextImage && (
        <div className={fundingListCardStyles.imageWrapper}>
          <div className={fundingListCardStyles.imageWrapperHelper}>{nextImage}</div>
        </div>
      )}
      <div className={fundingListCardStyles.content}>
        <div className={fundingListCardStyles.topWrapper}>
          <Heading variant={headingVariant} children={heading} />
          {text && text !== "" && <Text variant="paragraph" children={text} />}
        </div>
        <div className={fundingListCardStyles.bottomWrapper}>
          <Text variant="span" className={fundingListCardStyles.fundingDateWrapper}>
            <span className={fundingListCardStyles.fundingDateLabel}>Öppnar:</span>
            <span className={fundingListCardStyles.fundingDate}>
              {fundingOpeningDate ? fundingOpeningDate : "-"}
            </span>
          </Text>
          <Text variant="span" className={fundingListCardStyles.fundingDateWrapper}>
            <span className={fundingListCardStyles.fundingDateLabel}>Stänger:</span>
            <span className={fundingListCardStyles.fundingDate}>
              {fundingClosingDate ? fundingClosingDate : "-"}
            </span>
          </Text>
        </div>
      </div>
    </div>
  );
};

export default FundingListCard;
